var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRestore = function SvgRestore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-20": 16,
    "data-width-24": 19,
    viewBox: "0 0 11.8 12.4",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.822.6a.6.6 0 0 0-1.2 0v3.111a.6.6 0 0 0 .6.6h3.112a.6.6 0 0 0 0-1.2h-1.9c.751-.614 1.751-1.123 2.623-1.243a4.98 4.98 0 0 1 3.027.543 4.75 4.75 0 0 1 2.074 2.19 4.55 4.55 0 0 1 .3 2.947 4.67 4.67 0 0 1-1.588 2.537 4.93 4.93 0 0 1-2.856 1.107 4.96 4.96 0 0 1-2.97-.782 4.7 4.7 0 0 1-1.88-2.346.6.6 0 1 0-1.128.41 5.9 5.9 0 0 0 2.356 2.944 6.16 6.16 0 0 0 3.689.973 6.13 6.13 0 0 0 3.55-1.379 5.87 5.87 0 0 0 1.995-3.19 5.75 5.75 0 0 0-.378-3.724 5.95 5.95 0 0 0-2.596-2.744A6.18 6.18 0 0 0 4.895.679c-1.073.147-2.202.711-3.073 1.386z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRestore);
export default ForwardRef;